import MobilePhone48PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/MobilePhone48PxOutlined";
import Tablet48PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Tablet48PxOutlined";
import SmartWatch48PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/SmartWatch48PxOutlined";
import Laptop48PxOutlinedIcon from "@JohnLewisPartnership/jl-design-system/dist/elements/icons-jb/Laptop48PxOutlined";

const DeviceIcon = ({ category }: { category: string }) => {
  switch (category) {
    case "Phones":
      return <MobilePhone48PxOutlinedIcon />;
    case "Tablets":
      return <Tablet48PxOutlinedIcon />;
    case "Watches":
      return <SmartWatch48PxOutlinedIcon />;
    case "Macs":
      return <Laptop48PxOutlinedIcon />;
    default:
      return null;
  }
};

export default DeviceIcon;
